import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select, Button } from 'antd';
import debounce from 'lodash.debounce';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 20px;
`;

const LabelSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const { Option } = Select;

const StyledInput = styled.input`
  min-width: 289px;
  height: 32px;
  margin-top: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px;
`;

const Label = styled.label`
  color: #d0d7e3;
  width: 168px;
  height: 12px;
  display: flex;
  align-items: center;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
`;

const ItemText = styled.span`
  margin-left: 8px;
`;

const TopActionItemsComponent = ({
  onAutoFillDefault,
  onAutoFillRecommended,
  apiActions: {
    getAMLSCommonDynamicPropertiesCategories,
    getAMLSCommonDynamicProperties
  },
  dynPropertiesLoading,
  dynPropCategories,
  moduleId,
  subModule,
  showActionBtns,
  searchValue,
  handleSearchChange,
  selectedCategory,
  handleSelectCategory,
  disableRecommendedValueBtn = false
}) => {
  const [searchInputValue, setSearchInputValue] = useState('');

  // Convert dynPropCategories to an array if it's not already an array
  const dynPropCategoriesArray =
    dynPropCategories && Array.isArray(dynPropCategories)
      ? dynPropCategories
      : [];

  //dynPropCategories With All Category
  const dynPropCategoriesWithAll = ['All', ...dynPropCategoriesArray];

  useEffect(() => {
    const payload = { moduleId, subModule };
    getAMLSCommonDynamicPropertiesCategories(payload);
  }, [getAMLSCommonDynamicPropertiesCategories, moduleId, subModule]);

  const debouncedSearch = useRef(
    debounce((value) => handleSearchChange(value), 300)
  ).current;

  const handleSearch = useCallback(
    (value) => {
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(() => {
    setSearchInputValue(searchValue);
  }, [searchValue]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e.target.value);
    }
  };

  return (
    <Container>
      <LeftSection>
        <LabelSelectWrapper>
          <Label htmlFor="filterCategory">Filter Category</Label>
          <Select
            placeholder="Select Option"
            onChange={handleSelectCategory}
            style={{ width: '168px' }}
            value={selectedCategory}
            defaultValue="All"
            id="filterCategory">
            {dynPropCategoriesWithAll?.length &&
              dynPropCategoriesWithAll?.map((category) => (
                <Option key={category} value={category}>
                  {category}
                </Option>
              ))}
          </Select>
        </LabelSelectWrapper>
        <StyledInput
          type="text"
          placeholder="Enter property name to Search"
          onKeyDown={handleKeyDown} // Call handleSearch on pressing Enter
          value={searchInputValue}
          onChange={(e) => setSearchInputValue(e.target.value)}
        />
      </LeftSection>
      <RightSection>
        <Button
          type="primary"
          onClick={onAutoFillDefault}
          disabled={dynPropertiesLoading || !showActionBtns}>
          Auto-fill Default Values
        </Button>
        {!disableRecommendedValueBtn && (
          <Button
            type="primary"
            onClick={onAutoFillRecommended}
            disabled={dynPropertiesLoading || !showActionBtns}>
            Auto-fill Recommended Values
          </Button>
        )}
      </RightSection>
    </Container>
  );
};

// PropTypes of the component
TopActionItemsComponent.propTypes = {
  onAutoFillDefault: PropTypes.func.isRequired,
  onAutoFillRecommended: PropTypes.func.isRequired,
  apiActions: PropTypes.object.isRequired,
  dynPropertiesLoading: PropTypes.bool.isRequired,
  dynPropCategories: PropTypes.array.isRequired,
  moduleId: PropTypes.string.isRequired,
  subModule: PropTypes.string.isRequired,
  showActionBtns: PropTypes.bool.isRequired,
  searchValue: PropTypes.string.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  handleSelectCategory: PropTypes.func.isRequired,
  disableRecommendedValueBtn: PropTypes.bool
};

export default TopActionItemsComponent;
